"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _form = require("../../../forms/form");
var _customInputHoc = _interopRequireDefault(require("../custom-input-hoc"));
var _moment = _interopRequireDefault(require("moment"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _dateInput = require("./date-input");
var _timeSelectorInput = require("./time-selector-input");
var _timeData = require("../data/time-data");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var TimeSelectorInForm = (0, _customInputHoc.default)(_timeSelectorInput.TimeSelectorInput);
var DateSelectorInForm = (0, _customInputHoc.default)(_dateInput.DateInput);
var DateTimeForm = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimeForm, _React$Component);
  function DateTimeForm(props) {
    var _this;
    _classCallCheck(this, DateTimeForm);
    _this = _callSuper(this, DateTimeForm, [props]);
    _this.inputRefs = {};
    return _this;
  }
  _createClass(DateTimeForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        startTimeIndex = _this$props.startTimeIndex,
        endTimeIndex = _this$props.endTimeIndex,
        selectedDate = _this$props.selectedDate,
        isStartTimeOptional = _this$props.isStartTimeOptional,
        isEndTimeOptional = _this$props.isEndTimeOptional,
        formError = _this$props.formError,
        submitForm = _this$props.submitForm,
        submitFormCb = _this$props.submitFormCb,
        clearFilter = _this$props.clearFilter,
        selectStartTime = _this$props.selectStartTime,
        selectEndTime = _this$props.selectEndTime,
        onDayClick = _this$props.onDayClick,
        buttonText = _this$props.buttonText,
        _this$props$defaultSt = _this$props.defaultStartTimeIndex,
        defaultStartTimeIndex = _this$props$defaultSt === void 0 ? 6 : _this$props$defaultSt,
        _this$props$defaultEn = _this$props.defaultEndTimeIndex,
        defaultEndTimeIndex = _this$props$defaultEn === void 0 ? 22 : _this$props$defaultEn,
        intl = _this$props.intl;
      var startTimes = (0, _filter.default)(_timeData.TimeMap, function (value, key) {
        return 35 >= key;
      });
      var endTimes = (0, _filter.default)(_timeData.TimeMap, function (time) {
        return (startTimeIndex || defaultStartTimeIndex) < time.time_index;
      });
      var timeInputs = [{
        custom: /*#__PURE__*/_react.default.createElement("div", {
          className: "col-md-6 ".concat(this.props.dateColClass)
        }, /*#__PURE__*/_react.default.createElement(DateSelectorInForm, {
          ref: function ref(_ref) {
            _this2.inputRefs.date = _ref;
          },
          onDayClick: onDayClick,
          selectedDate: selectedDate,
          errorMessage: intl.formatMessage({
            id: 'shared_components.date_time_form.date_error',
            defaultMessage: 'Please enter a date'
          }),
          inputFieldName: "dateInput",
          optional: true
        }))
      }, {
        custom: function custom() {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "col-md-6 text-center"
          }, /*#__PURE__*/_react.default.createElement("h6", {
            className: "text-gray-dark search-by-date-header"
          }, selectedDate ? intl.formatDate(selectedDate, {
            weekday: 'long',
            month: 'short',
            day: 'numeric'
          }) : ''));
        }
      }, {
        custom: /*#__PURE__*/_react.default.createElement("div", {
          className: "time-group col-xs-6 col-md-3 no-gutter-right"
        }, /*#__PURE__*/_react.default.createElement(TimeSelectorInForm, {
          ref: function ref(_ref2) {
            _this2.inputRefs.startTime = _ref2;
          },
          optional: isStartTimeOptional,
          htmlId: "start-time",
          placeholder: "start time",
          selectedTimeIndex: startTimeIndex || defaultStartTimeIndex,
          onChangeHandler: selectStartTime,
          errorMessage: intl.formatMessage({
            id: 'shared_components.date_time_form.start_error',
            defaultMessage: 'Please enter a start time'
          }),
          timeData: startTimes,
          inputFieldName: "startTimeIndex",
          intl: intl
        }))
      }, {
        custom: /*#__PURE__*/_react.default.createElement("div", {
          className: "time-group col-xs-6 col-md-3 no-gutter-left"
        }, /*#__PURE__*/_react.default.createElement(TimeSelectorInForm, _extends({}, this.props, {
          ref: function ref(_ref3) {
            _this2.inputRefs.endTime = _ref3;
          },
          optional: isEndTimeOptional,
          htmlId: "end-time",
          placeholder: "end time",
          selectedTimeIndex: endTimeIndex || defaultEndTimeIndex,
          onChangeHandler: selectEndTime,
          errorMessage: intl.formatMessage({
            id: 'shared_components.date_time_form.end_error',
            defaultMessage: 'Please enter an end time'
          }),
          timeData: endTimes,
          inputFieldName: "endTimeIndex",
          intl: intl
        })))
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "DateTimeForm search-by-date dropdown-list",
        style: {
          margin: '0 -1px'
        }
      }, /*#__PURE__*/_react.default.createElement(_form.FormBuilder, {
        errorText: formError,
        inputRefs: this.inputRefs,
        formname: "search-by-date-form",
        formStyle: "standard",
        formInputs: timeInputs,
        submitAction: submitForm,
        submitCallback: submitFormCb,
        buttonText: buttonText || intl.formatMessage({
          id: 'shared_components.date_time_form.apply',
          defaultMessage: 'Apply'
        }),
        btnColSize: "form-btn-col col-xs-12",
        buttonClass: "btn btn-lg btn-block btn-primary form",
        containerClass: "form-btn-container",
        clearFilterFn: clearFilter
      }));
    }
  }]);
  return DateTimeForm;
}(_react.default.Component);
exports.DateTimeForm = (0, _reactIntl.injectIntl)(DateTimeForm);
DateTimeForm.propTypes = {
  startTimeIndex: _propTypes.default.string,
  endTimeIndex: _propTypes.default.string,
  selectedDate: _propTypes.default.object,
  isStartTimeOptional: _propTypes.default.bool,
  isEndTimeOptional: _propTypes.default.bool,
  formError: _propTypes.default.string,
  submitForm: _propTypes.default.func,
  submitFormCb: _propTypes.default.func,
  clearFilter: _propTypes.default.func,
  selectStartTime: _propTypes.default.func,
  selectEndTime: _propTypes.default.func,
  onDayClick: _propTypes.default.func,
  dateColClass: _propTypes.default.string,
  buttonText: _propTypes.default.string
};